module.exports = __webpack_public_path__ + "media/images/icons/phone_icon-c10d83e86cd25f19add8c91c0f6c9c9f.svg";